export type GetPrices = (
    value: number | undefined,
    currencyCode: string | undefined
) => { primaryPrice?: string; secondaryPrice?: string };

/**
 * Fixed. Will never be changed
 */
export const FIXED_EXCHANGE_RATE = 7.5345;

const insertEveryThirdDigitSeparators = (n: string, separator: string) => {
    return n.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, separator);
};

export const formatDualPriceValue = (value: number) => {
    const toFixed = value.toFixed(2);
    const [valueWithoutDecimal, decimals] = toFixed.split('.');
    const decimalsString = decimals !== '00' ? `,${decimals}` : '';
    const formattedPriceWithoutDecimals = insertEveryThirdDigitSeparators(valueWithoutDecimal.toString(), '.');
    return `${formattedPriceWithoutDecimals}${decimalsString}`;
};

export const getPrices: GetPrices = (value, currencyCode) => {
    if (currencyCode !== 'EUR' && currencyCode !== 'HRK') {
        throw new Error("Invalid currencyCode. Supported values: 'HRK' | 'EUR'");
    }
    if (value === undefined) return {};
    const eurValue = currencyCode === 'EUR' ? value : value / FIXED_EXCHANGE_RATE;
    const hrkValue = currencyCode === 'HRK' ? value : value * FIXED_EXCHANGE_RATE;

    const eurValueString = formatDualPriceValue(eurValue);
    const hrkValueString = formatDualPriceValue(hrkValue);

    const eurPrice = `${eurValueString} €`;
    const hrkPrice = `${hrkValueString} kn`;

    const primaryCurrency = currencyCode;
    return primaryCurrency === 'HRK'
        ? {
              primaryPrice: hrkPrice,
              secondaryPrice: eurPrice,
          }
        : {
              primaryPrice: eurPrice,
              secondaryPrice: hrkPrice,
          };
};
